@if (items && items.length && (size$ | async); as size) {
  @if (title) {
    <h2>{{ title }}</h2>
  }
  <div class="carousel-panel" [ngClass]="'size-' + size">
    @if (size < items.length) {
      <button
        [class]="activeSlide === 0 ? 'previous hidden' : 'previous'"
        (click)="activeSlide = activeSlide - size"
        [disabled]="activeSlide === 0"
      >
        <fa-icon [icon]="previousIcon"></fa-icon>
      </button>
    }
    <div class="slides">
      @for (_ of items; track _; let i = $index) {
        @if (i % size === 0) {
          <div class="slide" [class.active]="i === activeSlide">
            @for (
              item of items | slice: i : i + size;
              track item;
              let j = $index
            ) {
              @if (item | async; as data) {
                <div
                  class="item"
                  [class.active-item]="
                    size < items.length &&
                    activeSlide <= items.length - size - 1
                  "
                  [class.active]="i === activeSlide"
                >
                  <ng-container
                    *ngTemplateOutlet="template; context: { item: data }"
                  ></ng-container>
                </div>
              }
            }
          </div>
        }
      }
    </div>
    @if (size < items.length) {
      <button
        [class]="activeSlide > items.length - size - 1 ? 'next hidden' : 'next'"
        (click)="activeSlide = activeSlide + size"
        tabindex="-1"
        [disabled]="activeSlide > items.length - size - 1"
      >
        <fa-icon [icon]="nextIcon"></fa-icon>
      </button>
    }
  </div>
  @if (!hideIndicators && size < items.length) {
    <div class="indicators">
      @for (_ of items; track _; let i = $index) {
        @if (i % size === 0) {
          <button
            [disabled]="i === activeSlide"
            tabindex="-1"
            (click)="activeSlide = i"
          >
            @if (activeSlide === i) {
              <fa-icon [icon]="indicatorSelectedIcon"></fa-icon>
            } @else {
              <fa-icon [icon]="indicatorIcon"></fa-icon>
            }
          </button>
        }
      }
    </div>
  }
}
